import React from 'react'

interface CheckboxIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const CheckboxIcon: React.FC<CheckboxIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Checkbox icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M2 1.25h20a.75.75 0 01.75.75v20a.75.75 0 01-.75.75H2a.75.75 0 01-.75-.75V2A.75.75 0 012 1.25zM0 2a2 2 0 012-2h20a2 2 0 012 2v20a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm18.853 6.006a.607.607 0 00-.068-.86.616.616 0 00-.865.068l-7.107 8.282-3.77-3.699a.616.616 0 00-.866.006.607.607 0 00.005.862l4.239 4.16a.615.615 0 00.897-.039l7.535-8.78z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default CheckboxIcon
